import React from 'react';
import logoLinx from '../../images/logoLinx.png';
import './index.scss';

const Header: React.FC = () => (
  <div id="Header-Container">
    <div id="LogoLinx">
      <img src={logoLinx} />
    </div>
    <span id="TituloLinx">Linx</span>
    <div id="ContainerTitulo">
      <span id="TituloMonitoria">Monitoria</span>
      <span id="TituloIpiranga">Ipiranga</span>
    </div>
  </div>
);

export default Header;
